import script from "./InspectionKeyFigures.vue?vue&type=script&lang=ts&setup=true"
export * from "./InspectionKeyFigures.vue?vue&type=script&lang=ts&setup=true"

import "./InspectionKeyFigures.vue?vue&type=style&index=0&id=25a8f9c0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25a8f9c0"]])

export default __exports__